<template>
  <v-app id="inspire" class="fill-height">
    <v-main style="overflow: hidden">
      <video id="background-video" muted>
        <source src="../assets/Depositphotos_151324262_1080p.mp4" type="video/mp4" />
      </video>
      <v-container>
        <v-row align="center" justify="center">
          <v-col>
            <div class="fixed">
              <img class="tokenImageProfile" :src="img_quickproject" />
              <div class="fixed2">
                <v-card-subtitle style="color: #3f51b5; font-size: 35px; line-height: 1; text-align: center; font-weight: bold; border-radius: 0px 5px 0px 10px; margin-top: 20px; margin-bottom: 20px" class="text">Allegati Quickproject</v-card-subtitle>
                <div class="fixed3">
                  <v-data-table v-if="status_ok" :headers="headers_allegati" :items="lista_allegati" item-key="id_allegato" class="elevation-1" :key="tableKey">
                    <template v-slot:[`item.anteprima`]="{ item }">
                      <v-tooltip bottom v-if="item.id_allegato > 0 && item.tipo_file != 1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn small v-bind="attrs" v-on="on" @click="PreviewFile(item)">
                            <v-icon color="primary">{{ item.keys == null || item.keys == "" ? "mdi-eye" : "mdi-eye-lock" }}</v-icon>
                          </v-btn>
                        </template>
                        <span>Anteprima</span>
                      </v-tooltip>
                    </template>

                    <!-- Bottone dei Download -->
                    <template v-slot:[`item.scarica`]="{ item }">
                      <v-tooltip bottom v-if="item.id_allegato > 0 && item.tipo_file != 1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn small v-bind="attrs" v-on="on" @click="DownloadFileNew(item)">
                            <v-icon color="primary">{{ item.keys == null || item.keys == "" ? "mdi-download" : "mdi-download-lock" }}</v-icon>
                          </v-btn>
                        </template>
                        <span>Scarica</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                  <v-card-subtitle v-else style="color: #3f51b5; font-size: 35px; line-height: 1; text-align: center; font-weight: bold; border-radius: 0px 5px 0px 10px; margin-top: 20px; margin-bottom: 20px" class="text">Link degli allegati è scaduto.</v-card-subtitle>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

        <div style="position: absolute; bottom: 0px; right: 0px; color: gray; font-size: 12px; padding: 2px">v.{{ this.$store.state.versione }}</div>
      </v-container>
      <v-dialog v-model="dxfDialog" width="800">
        <DxfViewer ref="viewer" :dxfUrl="dxfurl" />
      </v-dialog>
      <v-dialog v-model="imgDialog" width="80vw" scrollable>
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">Anteprima Allegato</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="DownloadFromPreview" small v-bind="attrs" v-on="on">
                  <v-icon color="success">mdi-download</v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="imgDialog = false" small v-bind="attrs" v-on="on" class="ml-5">
                  <v-icon color="error">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <img :src="imgSrc" style="max-width: 100%" />
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- Overlay -->
      <v-overlay color="rgba(0, 0, 0, 1)" style="position: absolute" :value="caricamento_dati">
        <v-icon class="ConsuntivoWORuota" size="100">mdi-cog</v-icon>
        <v-icon class="ConsuntivoWOControruota" size="100">mdi-cogs</v-icon>
      </v-overlay>
      <SnackbarQV ref="SnackbarQV" />
    </v-main>
  </v-app>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import DxfViewer from "@/components/TOOLS/DxfViewer.vue";
export default {
  name: "Allegati",
  components: {
    SnackbarQV,
    DxfViewer,
  },
  props: {
    obbligatorio: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      status_ok: false,
      loading3: false,
      caricamento_dati: false,
      img_quickproject: null,

      max_resolution: -1,
      fotoPromptDlg: false,
      is_admin: 0,
      progressDialog: false,
      progressMode: 0,
      progressValue1: 0,
      progressMax1: 100,
      progressValue2: 0,
      progressMax2: 100,
      chunkSize: 524288,
      // Variabili d'appoggio
      utenti: [],
      authDialog: false,
      id_profilo: null,
      secureUpload: 0,
      simplified: false,
      filtroNome: null,
      filtroTipo: null,
      showFilters: true,
      show_close: true,
      showCanvas: false,
      current_view: "environment",
      fotoDialog: false,
      cameraStream: null,
      cameraW: 0,
      cameraH: 0,
      cameraA: 0,
      tempPic: null,
      showVideo: true,
      mobile: false,
      readonly: false,
      dialogDettaglioGenerali: false,
      tempAllegatoGenerale: "",
      overlay: false,
      dialogGenerali: false,
      listMancanti: "",
      tableKey: true,
      tempItem: null,
      tempFile: null,
      imgDialog: null,
      imgSrc: null,
      allegato_sel: {},
      dettaglio_allegato_visible: false,
      allegato_mod: {},
      cartella_mod: {},
      allegato_nuova_vers: {},
      id_utente: null,
      id_allegato_tmp: null,
      close_after_save: false,
      operation_error: false,
      //proprieta per osservare i cambiamenti, se mantenessi solo id_riferimento non riuscire a fare creazione quindi setGenitore e dopo cambiare la prop dell' id_riferimento
      // e quindi richiamare tutto il set del Componente
      id_riferimento_creazione_genitore: "",
      linkVideo: null,
      dxfurl: null,
      selectedPdf: "",
      nome_cartella: "",
      stringa_lista: "",
      scadenza_predefinita: "",
      // Modal
      dialog_header_detail: false,
      dialogPdf: false,
      dialogScadenze: false,
      videoPlayer: false,
      dxfDialog: false,
      dialog_dettaglio_file: false,
      dialog_dettaglio_cart: false,
      dialog_storico: false,
      dialog_riepilogo: false,
      sostituzione: false,
      inserimento_sotto: true,
      dialog_nuova_cartella: false,
      dialog_carica_cartella: false,
      dialog_modifiche_da_salvare: false,

      lista_allegati: [],
      headers_allegati: [
        { text: "Anteprima", value: "anteprima", witdh: "50px", sortable: false },
        { text: "Scarica", value: "scarica", witdh: "50px", sortable: false },
        { text: "Nome", value: "nome_file", witdh: "150px", sortable: false },
        { text: "Tipologia", value: "tipo_allegato", witdh: "200px", sortable: false },
        { text: "Famiglia", value: "famiglia_allegato", witdh: "200px", sortable: false },
        { text: "Emesso da", value: "emesso_da", witdh: "200px", sortable: false },
        { text: "Data scadenza", value: "data_fine_validita", witdh: "150px", sortable: false },
      ],
    };
  },
  methods: {
    async getAllegati() {
      let request = {
        controller: "contabilita",
        method: "POST",
        richiesta: {
          action: "getallegati",
          token: this.obbligatorio,
        },
      };

      await this.$store.dispatch("api6", request).then(async (res) => {
        if (res.status === 200 && res.data != "") {
          this.status_ok = true;
          this.lista_allegati = res.data.result.allegati;
          this.img_quickproject = res.data.result.img_quickproject[0].img_modulo ? res.data.result.img_quickproject[0].img_modulo : null;
        } else {
           this.status_ok = false;
        }
      }).catch(()=>{
         this.status_ok = false;
      });
    },

    async DownloadFileNew(arg) {
      this.operation_error = false;
      this.progressMode = 1;
      this.progressValue2 = 0;
      this.progressMax2 = 1;
      this.progressDialog = true;
      const fileid = Date.now();
      var n = 0;
      var end = false;
      var arrFile = new Uint8Array(0);
      while (!end) {
        let request = {
          controller: this.is_admin == 1 ? "secure" : "eallegati",
          method: "POST",
          richiesta: {
            action: "downloadchunk",
            guid_file: arg.guid_file,
            estensione: arg.estensione,
            id_allegato: arg.id_allegato,
            file_id: fileid,
            num_bytes: this.chunkSize,
            num_chunk: n,
            db_name: arg.db_name,
            token: this.obbligatorio,
          },
        };
        await this.$store
          .dispatch("api6", request)
          .then((res) => {
            this.progressMax2 = res.data.result.total;
            end = res.data.result.end;
            const chunk = this.base64ToArray(res.data.result.data);
            var tempArr = new Uint8Array(chunk.length + arrFile.length);
            tempArr.set(arrFile);
            tempArr.set(chunk, arrFile.length);
            arrFile = tempArr;
          })
          .catch(() => {
            this.operation_error = true;
            end = true;
          });

        n++;
        this.progressValue2++;
      }

      if (this.operation_error) return;

      const blob = new Blob([arrFile], {
        type: "application/octet-stream",
      });

      let b64 = await this.blobToBase64(blob);
      var a = document.createElement("a");
      a.setAttribute("download", arg.nome_file + arg.estensione);
      a.href = b64;
      document.body.appendChild(a);
      a.click();
      a.remove();
      this.progressDialog = false;
    },

    async PreviewFile(arg) {
      this.progressMode = 1;
      this.progressValue2 = 0;
      this.progressMax2 = 1;
      this.progressDialog = true;
      const fileid = Date.now();
      var n = 0;
      var end = false;
      var arrFile = new Uint8Array(0);
      while (!end) {
        let request = {
          controller: this.is_admin == 1 ? "secure" : "eallegati",
          method: "POST",
          richiesta: {
            action: "downloadchunk",
            guid_file: arg.guid_file,
            estensione: arg.estensione,
            id_allegato: arg.id_allegato,
            file_id: fileid,
            num_bytes: this.chunkSize,
            num_chunk: n,
            db_name: arg.db_name,
            token: this.obbligatorio,
          },
        };
        await this.$store.dispatch("api6", request).then((res) => {
          this.progressMax2 = res.data.result.total;
          end = res.data.result.end;
          const chunk = this.base64ToArray(res.data.result.data);
          var tempArr = new Uint8Array(chunk.length + arrFile.length);
          tempArr.set(arrFile);
          tempArr.set(chunk, arrFile.length);
          arrFile = tempArr;
        });
        n++;
        this.progressValue2++;
      }

      this.progressDialog = false;

      const est = arg.estensione.toLowerCase();
      if (est == ".png" || est == ".bmp" || est == ".jpg" || est == ".jpeg") {
        const imgBlob = new Blob([arrFile], {
          type: "data:image/" + est.replace(".", ""),
        });
        let imgB64 = await this.blobToBase64(imgBlob);
        this.imgSrc = imgB64;
        this.imgDialog = true;
      } else if (est == ".pdf") {
        const pdfBlob = new Blob([arrFile], {
          type: "application/pdf",
        });
        const blob_urlPdf = URL.createObjectURL(pdfBlob);
        window.open(blob_urlPdf, "_blank");
      } else if (est == ".dxf") {
        const dxfBlob = new Blob([arrFile], {
          type: "application/octet-stream",
        });
        const file = new File([dxfBlob], "dxffile.dxf", { type: "" });
        this.dxfurl = URL.createObjectURL(file);
        this.dxfDialog = true;
      } else {
        const blob = new Blob([arrFile], {
          type: "application/octet-stream",
        });
        let b64 = await this.blobToBase64(blob);
        var a = document.createElement("a");
        a.setAttribute("download", arg.nome_file + arg.estensione);
        a.href = b64;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    },

    base64ToArray(base64) {
      var binaryString = atob(base64);
      var bytes = new Uint8Array(binaryString.length);
      for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes;
    },
    async blobToBase64(blob) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },
  },

  async mounted() {
    await this.getAllegati();
  },
};
</script>

<style scoped>
#background-video {
  width: 110vw;
  height: 110vh;
  position: fixed;
  left: -30px;
  top: 0;
  filter: opacity(0.96) drop-shadow(0 0 0 rgb(255, 255, 255)) blur(18px) brightness(1.1);
}
</style>
<style lang="scss" scoped>
.tokenImageProfile {
  margin: 10px 10px 10px 10px;
  border-radius: 0.5rem;
  height: 110px;
}

.fixed {
  border: 0.5px solid rgba(254, 254, 254, 0.3);
  background: rgba(255, 255, 255, 0.7);
  // box-shadow: rgba(61, 61, 61, 0.404) 0px 6px 12px -2px,
  //     rgba(0, 0, 0, 0.453) 0px 3px 7px -3px;
  box-shadow: 3px 3px 40px 3px rgba(30, 30, 30, 0.7);
  border-radius: 12px;
  backdrop-filter: blur(60px);
  -webkit-backdrop-filter: blur(60px);
  filter: brightness(1);
  position: fixed;
  height: 130px;
  max-width: 200px;
  min-width: 200px;
  left: 50%;
  top: 5%;
  margin-left: -100px;
}

.fixed2 {
  border: 0.5px solid rgba(254, 254, 254, 0.3);
  background: rgba(255, 255, 255, 0.7);
  // box-shadow: rgba(61, 61, 61, 0.404) 0px 6px 12px -2px,
  //     rgba(0, 0, 0, 0.453) 0px 3px 7px -3px;
  box-shadow: 3px 3px 40px 3px rgba(30, 30, 30, 0.7);
  border-radius: 12px;
  backdrop-filter: blur(60px);
  -webkit-backdrop-filter: blur(60px);
  filter: brightness(1);
  position: fixed;
  height: 100px;
  max-width: 500px;
  min-width: 500px;
  left: 50%;
  top: 115%;
  margin-left: -250px;
}

.fixed3 {
  border: 0.5px solid rgba(254, 254, 254, 0.3);
  background: rgba(255, 255, 255, 0.7);
  // box-shadow: rgba(61, 61, 61, 0.404) 0px 6px 12px -2px,
  //     rgba(0, 0, 0, 0.453) 0px 3px 7px -3px;
  box-shadow: 3px 3px 40px 3px rgba(30, 30, 30, 0.7);
  border-radius: 12px;
  backdrop-filter: blur(60px);
  -webkit-backdrop-filter: blur(60px);
  filter: brightness(1);
  position: fixed;
  width: 1500px;
  height: auto;
  max-height: 700px;
  overflow: auto;
  top: 120%;
  left: 50%;
  margin-left: -750px;
}
</style>
